function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.147 3.82903C34.2429 2.93215 33.1695 2.22067 31.988 1.73526C30.8066 1.24984 29.5402 1 28.2614 1C26.9825 1 25.7162 1.24984 24.5348 1.73526C23.3533 2.22067 22.2799 2.93215 21.3758 3.82903L19.4995 5.68952L17.6233 3.82903C15.7971 2.01823 13.3203 1.00094 10.7377 1.00094C8.15508 1.00094 5.67827 2.01823 3.8521 3.82903C2.02593 5.63983 1 8.0958 1 10.6567C1 13.2175 2.02593 15.6735 3.8521 17.4843L5.72837 19.3448L19.4995 33L33.2707 19.3448L35.147 17.4843C36.0515 16.5878 36.769 15.5234 37.2585 14.3519C37.748 13.1804 38 11.9247 38 10.6567C38 9.38856 37.748 8.1329 37.2585 6.96139C36.769 5.78989 36.0515 4.7255 35.147 3.82903V3.82903Z",
  stroke: "#01F2B4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFavourites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "-3 -3 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.422e75cf1282724fcd32f0ffde49af02.svg";
export { ForwardRef as ReactComponent };